// src/internal/components/header/header.utils.ts
function getVariantProps(variant) {
  var _a;
  if (!variant)
    return {};
  const variants = {
    account: {
      minWidth: (theme) => theme.spacing(240 / 8),
      maxWidth: (theme) => theme.spacing(320 / 8)
    },
    actions: {
      spacing: 1,
      direction: "row"
    },
    navigation: { mb: 1 },
    title: {},
    tools: {
      alignItems: "center",
      justifyContent: "flex-end",
      direction: "row"
    },
    banner: {
      alignItems: "center",
      direction: "row"
    }
  };
  return (_a = variants == null ? void 0 : variants[variant]) != null ? _a : {};
}
function getColorScheme(theme) {
  return {
    bgcolor: theme.palette.common.white,
    color: theme.palette.v3.content.high_emphasis,
    borderBottom: "1px solid",
    borderColor: theme.palette.grey[300]
  };
}

export {
  getVariantProps,
  getColorScheme
};
